import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-blush py-12 sm:py-16" data-id="element-119" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-2xl px-5" data-id="element-120" data-mp="4vjkdx5iasbg">
        <div className="rounded-3xl border-2 border-rose/20 bg-white p-6 text-center shadow-lg shadow-rose/10 sm:p-8" data-id="element-121" data-mp="9ttj2hqfwb1t">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blush" data-id="element-122" data-mp="euhbn7ubgzy5">
            <ShieldCheckIcon className="h-6 w-6 text-rose-deep" aria-hidden data-id="element-123" data-mp="jrr5r0snhzsb" />
          </span>
          <h2 className="mt-4 font-display text-xl font-black text-ink sm:text-3xl" data-id="element-124" data-mp="nt2p4okxlos2">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-ink/75 sm:text-base" data-id="element-125" data-mp="sn6w37u75wt5">
            Abrís los tomos. Los aplicás en tu perfil. Si en 7 días no es lo que esperabas,
            solicitás la devolución del 100%.
          </p>
        </div>
      </div>
    </section>;
}